import { uriRoles } from '@/router/uri-roles.ts'
import { routeNames } from '@/router/route-names.ts'
import type { SelectRouterItem } from '@/types'

export const tmSelectedRouterList: SelectRouterItem[] = [
  {
    value: 1,
    title: 'Danh sách công việc',
    name: routeNames.TaskList,
    uriRole: uriRoles.TaskList,
    routeName: routeNames.TaskList,
    disabled: false,
  },
]
